interface AjaxConfig {
    ajaxurl: string;
    nonce: string;
}

declare const personioApplication: AjaxConfig;
declare const personioUpload: AjaxConfig;

export const createApplicationFormData = ( form: HTMLFormElement ): FormData => {
    const data = new FormData( form );

    data.append( 'action', 'personio_submit_application' );
    data.append( 'nonce', personioApplication.nonce );

    return data;
}

export const createUploadApplicationDocumentFormData = ( file: File ): FormData => {
    const data = new FormData();

    data.append( 'action', 'personio_upload_file' );
    data.append( 'nonce', personioUpload.nonce );
    data.append( 'file', file, file.name );

    return data;
}

export const submitApplication = async ( body: FormData ): Promise<Response> => {
    return await fetch(
        personioApplication.ajaxurl,
        {
            method: 'POST',
            body: body,
            credentials: 'same-origin'
        }
    );
}

export const uploadApplicationDocument = async ( body: FormData ): Promise<Response> => {
    return await fetch(
        personioUpload.ajaxurl,
        {
            method: 'POST',
            body: body,
            credentials: 'same-origin'
        }
    );
}
